var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "containerRef",
      staticClass: "c-saturation",
      style: { background: _setup.bgColor },
      on: {
        pointerdown: _setup.handleMouseDown,
        pointermove: _setup.handleMouseMove,
        pointerup: _setup.handleMouseUp,
        pointercancel: _setup.handleMouseUp,
      },
    },
    [
      _c("div", { staticClass: "c-saturation--white" }),
      _vm._v(" "),
      _c("div", { staticClass: "c-saturation--black" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "c-saturation-pointer",
          style: { top: _setup.pointerTop, left: _setup.pointerLeft },
        },
        [_c("div", { staticClass: "c-saturation-circle" })]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }